import { SvgIcon } from "@mui/material"

import { ReactComponent as OngoingIcon } from "./ongoing.svg"

export const StatusOngoingIcon = (props) => {
    return (
        <SvgIcon component={OngoingIcon} {...props} inheritViewBox />
    )
}